
export interface ReviewCreateRequest {
  /** 리뷰 코멘트 */
  comment: string;
  /**
   * 별점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  rating: number;
}
